import { urlsConstants } from '../constants/url.constant';
import { defaultService } from './defaultService';

export const estoqueInternoService = {
  consultarSaldo,
  ajustarSaldoManual,
};

function consultarSaldo(codigoCliente, produtoId) {
  const query = `?codigoCliente=${encodeURIComponent(
    codigoCliente,
  )}&produtoId=${encodeURIComponent(produtoId)}`;

  return defaultService.doGet(
    `${urlsConstants.API_ESTOQUE_INTERNO}saldo${query}`,
  );
}

function ajustarSaldoManual(payload) {
  return defaultService.doPost(
    `${urlsConstants.API_ESTOQUE_INTERNO}ajusteManual`,
    payload,
  );
}
